module.exports = __webpack_public_path__ + "img/svg/background-no-money.324fb00261a9d9f60cbaea66c8544da8.svg";